import React, { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import VisibilitySettingsModal from '@/components/Form/components/VisibilitySettings/legacy/LegacyVisibilitySettingsModal';
import { VisibilitySettingsInput } from '@/types/schema';

import { DialogProps } from '../../types';

const VisibilitySettings: React.FC<DialogProps> = ({ content, onSubmit, onClose }) => {
  const { t } = useTranslation();
  const articleVisibilitySettings = content.visibilitySettings as VisibilitySettingsInput;

  const onSubmitHandler = useCallback(
    async (visibilitySettings: any) => {
      return onSubmit?.({
        visibilitySettings,
      });
    },
    [onSubmit],
  );

  return (
    <VisibilitySettingsModal
      contentName={t('Common:ResourceType.Article')}
      visibilitySettings={articleVisibilitySettings}
      onClose={onClose}
      onSubmit={onSubmitHandler}
    />
  );
};

export default VisibilitySettings;
